<template>
	<div class="auswertung">
		<h1>Auswertung</h1>
		<p>Arbeitsdichte umfasst sieben Facetten, die weiter unten n&auml;her erl&auml;utet werden. Wenn Sie den Fragebogen mehrmals beantwortet haben, so beachten Sie bitte, dass sich die hier dargestellten Werte auf die <u>letzte Erhebung</u> beziehen.</p>
		<v-expansion-panels>
			<v-expansion-panel v-model="benchmarkPanel">
				<v-expansion-panel-header>Benchmark</v-expansion-panel-header>
				<v-expansion-panel-content>
					<p>Sie können Ihre Ergebnisse mit einem Benchmark vergleichen, der aus den Ergebnissen bisheriger Teilnehmer berechnet wird. Dazu wird der Hintergrund eingefärbt. Die Interpretation erfolgt nach dem "Ampel-Prinzip": Eine gelbe Farbe markiert den durchschnittlichen Bereich. Der grüne bzw. rote Bereich markieren über- bzw. unterdurchschnittliche Ausprägungen. Bitte beachten, Sie dass dieser Vergleich lediglich eine erste Orientierung sein kann.</p>
					<p><v-checkbox v-model="benchmarkAnzeigen" label="Ich möchte meine Ergebnisse mit einem Benchmark vergleichen."></v-checkbox></p>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel v-model="gruppePanel" v-show="gruppePanelAnzeigen">
				<v-expansion-panel-header>Gruppe</v-expansion-panel-header>
				<v-expansion-panel-content>
					<p>
						<v-checkbox v-model="gruppeAnzeigen" label="Gruppenauswertung anzeigen"></v-checkbox>
					</p>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
		<p>&nbsp;</p>
		<v-card v-for="(facette, facettex) in facetten" v-bind:key="facettex" class="facettenkarte">
			<v-card-title>
				{{facette.titel}}
			</v-card-title>
			<v-card-text>
				<img class="bericht" src="../assets/bericht.svg" alt="Bericht" />
				<ampel :skala="facette.skala" :benchmarkAnzeigen="benchmarkAnzeigen" :gruppe="gruppe" :gruppeAnzeigen="gruppeAnzeigen"></ampel>
				<p>{{facette.beschreibung}}</p>
			</v-card-text>
			<v-card-actions>
				<auswertungdetail :facette="facette.skala"></auswertungdetail>
			</v-card-actions>
		</v-card>
		<!-- <v-expansion-panels>
			<v-expansion-panel v-model="verlaufPanel">
				<v-expansion-panel-header>Verlauf</v-expansion-panel-header>
				<v-expansion-panel-content>
					<p>Dieses Diagramm zeigt die Veränderung der einzelnen Facetten der Arbeitsdichte im Verlauf der einzelenen Erhebungen. Wenn Sie die einzelnen Positionen in der Legende anklicken, können Sie die jeweilige Facette aus- und einblenden.</p>
					<verlauf skala="avi"></verlauf>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>		 -->
	</div>
</template>
<script>
	import ampel from '../components/ampel.vue';
	import auswertungdetail from '../components/auswertungdetail.vue';
	// import verlauf from '../components/verlauf.vue';
	export default {
		name: 'auswertung',
		components: {
			ampel,
			auswertungdetail
			// verlauf
		},
		data: function () {
			return {
				skala: 'avi',
				auswertung: {},
				teilnehmer_m: {},
				facetten: {
					avi_mg: {skala: "avi_mg", avKriterium: "av1", titel: "Menge", beschreibung: "Menge der Aufgaben, die in einem gewissen Zeitraum anfallen."},
					avi_ub: {skala: "avi_ub", avKriterium: "av2", titel: "Unterbrechungen", beschreibung: "Ausmaß der Unterbrechungen bei der Bearbeitung von Aufgaben."},
					avi_gz: {skala: "avi_gz", avKriterium: "av3", titel: "Gleichzeitigkeit", beschreibung: "Ausmaß der parallel zu erledigenden Aufgaben."},
					avi_id: {skala: "avi_id", avKriterium: "av4", titel: "Interdependenz", beschreibung: "Ausmaß der Vernetzung der Beschäftigten zur Aufgabenerfüllung."},
					avi_as: {skala: "avi_as", avKriterium: "av5", titel: "Arbeitsspitzen", beschreibung: "Zeitweilige Häufung von Aufgaben."},
					avi_ee: {skala: "avi_ee", avKriterium: "av6", titel: "Erweiterte Erreichbarkeit", beschreibung: "Erreichbarkeit außerhalb der regulären Arbeitszeit."},
					avi_uk: {skala: "avi_uk", avKriterium: "av7", titel: "Unklarheit", beschreibung: "Fehlende Klarheit hinsichtlich der Aufgabenerfüllung und der eigenen Rolle."}
				},
				benchmarkAnzeigen: false,
				benchmarkPanel: false,
				gruppePanel: false,
				gruppePanelAnzeigen: false,
				verlaufPanel: false,
				gruppeAnzeigen: false,
				gruppe: 'ba',
				auswertungdetailAnzeigen: false
			}
		},
		created() {
			// this.teilnehmer = this.setTeilnehmer('r5ra77b4qbte461m');
		},
		mounted() {
			console.log(this.$route.query.b);
			if (this.$route.query.b) {
				this.gruppe = this.$route.query.b;
				this.gruppePanelAnzeigen = true;
			} else {
				this.gruppePanelAnzeigen = false;
			}
		},
		methods: {
			setTeilnehmer(kennung) {
				this.$store.dispatch('setTeilnehmer', kennung);
			},
			auswertungDetails: function(facette) {
				console.log(facette);
				this.auswertungdetailAnzeigen = true;
				// this.aktuelleFacette = this.facetten[facette];
			}
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		}
	}
</script>
<style scoped>
	.facettenkarte {
		margin-bottom: 1em;
	}
	.bericht {
		cursor: pointer;
		height: 41px;
		float: right;
		display: none;
	}
	.ampel {
		margin-top: -2.5em;
		display: block;
		float: right;
		width: 100%;
		max-width: 400px;
	}
</style>
